import React, { useEffect } from 'react'
import Layout from "../../NewComponent/LayoutExpert/Layout";
import SearchBar from "../../NewComponent/SearchBar/SearchBar";
import Filters from './Filters';
import { useSelector, useDispatch } from 'react-redux';
import { getExpertsProfilePics, newTrendingAPITwo } from '../../API/api';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import {Spin, Empty} from 'antd';
import TrendingQA from '../../NewComponent/answerBox/TrendingQA/index';
import PaginationTwo from '../../NewComponent/PaginationTwo/Pagination';
import KeyTagDataBox from '../KeyTermPage/KeyTagDataBox';

export default function NewTrendingExpertPage() {
  const trendingState = useSelector(state=>state.trending);
  const keyTagState = useSelector(state=>state.keyTag);

  const dispatch = useDispatch();
  const {isTrendingLoadMore,getTrendingQA,getTrendingDataLoadingStatus,trendingDataSelectPageNo, updateTrendingIndex} = bindActionCreators(Actions, dispatch);
  const {pageNo,sortFilter,domains,expertIndex,threadIndex,searchIndex,viewIndex,acceptedIndex,indexes} = trendingState;
  const container = {
    width: "74%",
    margin: "auto",
    marginTop: "1%",
    marginBottom: "7%",
    border: "1px solid #E0E2E6",
    background: "#FFFFFF",
    borderRadius: "12px",
    boxShadow: "0px 4px 16px 0px #1018280F",
    padding: "28px",
  };
  useEffect(()=>{
    getTrendingDataLoadingStatus(true);
    newTrendingAPITwo(pageNo,sortFilter, domains,indexes[pageNo].expertIndex,indexes[pageNo].threadIndex,indexes[pageNo].searchIndex,indexes[pageNo].viewIndex,indexes[pageNo].acceptedIndex,trendingState.searchQuery).then(res=>{
      if(res===undefined){
        return;
      } 
      if(indexes[pageNo+1]===undefined){
        let newIndexes = {...indexes};
        newIndexes[pageNo+1] ={
            expertIndex: res.data.data.expertIndex,
            threadIndex: res.data.data.threadIndex,
            searchIndex: res.data.data.searchIndex,
            viewIndex: res.data.data.viewIndex,
            acceptedIndex: res.data.data.acceptedIndex,
        }
        updateTrendingIndex(newIndexes);
      }
      isTrendingLoadMore([res.data.data.expertIndex,res.data.data.threadIndex,res.data.data.searchIndex,res.data.data.viewIndex,res.data.data.acceptedIndex, true]);
      getTrendingQA(res.data.data.records);
      getTrendingDataLoadingStatus(false)
    })
  },[trendingState.sortFilter, trendingState.searchQuery, trendingState.domains, trendingState.pageNo, trendingState.reloadPage]);
  // console.log("trending state",trendingState)
  return (
    <Layout>
        {!keyTagState.isBack &&
        <div style={{width:'74%',margin:'auto', marginTop:'1%', marginBottom:"3%"}}>
        <SearchBar/>
        </div>}
        <div style={container}>
          {!keyTagState.isBack && <div>
          <div className="mb-4">
            <Filters/>
          </div>
          {trendingState.isLoading &&<Spin size="large" spinning={true}>
          <div style={{ height: "100px" }}></div>
        </Spin>}
        {!trendingState.isLoading && trendingState.data2.length === 0 && <div className="mt-4"><Empty /></div>}
        {!trendingState.isLoading && trendingState.data2.length !== 0&& trendingState.data2.map(qa=>{
          // console.log("qa",qa)
          return(
            <TrendingQA data={qa.answersList===undefined?[]:qa.answersList} question={qa} />
          )
        })}
        {!trendingState.isLoading && trendingState.searchQuery.length === 0 && <PaginationTwo pageNo={pageNo} onChangeFunc={trendingDataSelectPageNo}/>}
          </div>}
          {keyTagState.isBack && <KeyTagDataBox />}
        </div>
    </Layout>
  )
}
